import { c as _c } from "react/compiler-runtime";
import ChangeIcon from '@/assets/icons/heroIcons/Calendar-change.svg';
import InstallmentsIcon from '@/assets/icons/heroIcons/Installments.svg';
import CardsIcon from '@/assets/icons/heroIcons/Cards.svg';
import { Card } from '@/components/StackCards/types';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import { Button } from '@/components/buttons';
import { mergeClasses } from '@/utils/style';
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { StackCards } from '@/components/StackCards';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { AnimatedSection, AnimatedContent } from '@/components/animation';
import { NumericRange } from '@/types/range';
import { getSectionAnchorId } from '@/utils/anchors';
import { useProductRegistrationLink } from '@/hooks/useProductRegistrationLink';
function Benefits() {
  const $ = _c(60);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core", "revolvingLoan"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const numberOfCards = 5;
  const registrationLink = useProductRegistrationLink("balicek-maxi");
  let t1;
  if ($[1] !== registrationLink || $[2] !== t) {
    t1 = Array.from({
      length: 5
    }, (_, index) => {
      const cardIndex = index + 1 as NumericRange<1, 5>;
      if (cardIndex < 1 || cardIndex > 5) {
        throw new Error(`Invalid card index: ${cardIndex}. Ensure translations exist for all indices.`);
      }
      return {
        index,
        menuTitle: "",
        title: <div className={mergeClasses(cardIndex === 5 && "text-center lg:text-left")}>{t(`revolvingLoan:cards.items.${cardIndex}.title`)}</div>,
        ...(cardIndex < 5 ? {
          description: cardIndex === 1 ? <Trans t={t} i18nKey={`revolvingLoan:cards.items.${cardIndex}.text`}><Link to={registrationLink} testId="revolvingLoanCardsRegisterToPlus" analyticsParam="revolvingLoanCardsRegisterToPlus" /></Trans> : cardIndex === 2 ? <Trans t={t} i18nKey={`revolvingLoan:cards.items.${cardIndex}.text`}><Link to={LINKS().card} testId="revolvingLoanCardsAboutPaymentCard" analyticsParam="revolvingLoanCardsAboutPaymentCard" /></Trans> : t(`revolvingLoan:cards.items.${cardIndex}.text`)
        } : {
          footer: <Button analyticsParam="revolvingLoanCardsiWantMaxi" testId="revolvingLoanCardsiWantMaxi" variant="primary" size="lg" className="m-auto w-full md:w-auto lg:m-0" to={registrationLink}>{t(`revolvingLoan:cards.items.${cardIndex}.text`)}</Button>
        }),
        images: {
          desktop: {
            src: `/images/sections/revolvingLoan/cards/cs/${cardIndex}.png`,
            alt: t(`revolvingLoan:cards.items.${cardIndex}.title`)
          },
          mobile: {
            src: `/images/sections/revolvingLoan/cards/cs/${cardIndex}.png`,
            alt: t(`revolvingLoan:cards.items.${cardIndex}.title`)
          },
          ...(cardIndex < 5 && {
            variant: "appMockup"
          })
        }
      };
    });
    $[1] = registrationLink;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cards = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getSectionAnchorId("benefits");
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("revolvingLoan:benefitsSection.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <SectionHeadline className="mb-10 lg:mb-16" variant="inverted" anchorKey="revolvingLoan.benefitsSection.title">{t3}</SectionHeadline>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("revolvingLoan:benefitsSection.benefits.item.1.title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("revolvingLoan:benefitsSection.benefits.item.1.paragraph");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CardsIcon />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6) {
    t8 = {
      title: t5,
      paragraph: t6,
      icon: t7
    };
    $[14] = t5;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("revolvingLoan:benefitsSection.benefits.item.2.title");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("revolvingLoan:benefitsSection.benefits.item.2.paragraph");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <InstallmentsIcon />;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t9) {
    t12 = {
      title: t9,
      paragraph: t10,
      icon: t11
    };
    $[22] = t10;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("revolvingLoan:benefitsSection.benefits.item.3.title");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("revolvingLoan:benefitsSection.benefits.item.3.paragraph");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ChangeIcon />;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t13 || $[31] !== t14) {
    t16 = {
      title: t13,
      paragraph: t14,
      icon: t15
    };
    $[30] = t13;
    $[31] = t14;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t12 || $[34] !== t16 || $[35] !== t8) {
    t17 = <InfoBoxes items={[t8, t12, t16]} variant="inverted" withCharacters={false} />;
    $[33] = t12;
    $[34] = t16;
    $[35] = t8;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("revolvingLoan:benefitsSection.button");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== registrationLink || $[40] !== t18) {
    t19 = <Button testId="revolvingLoanBenefitsGoToRevolving" analyticsParam="revolvingLoanBenefitsGoToRevolving" variant="primary" align="center" size="lg" to={registrationLink}>{t18}</Button>;
    $[39] = registrationLink;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t17 || $[43] !== t19) {
    t20 = <div className="mb-28 flex flex-col gap-12 lg:mb-40 lg:gap-16">{t17}{t19}</div>;
    $[42] = t17;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t20 || $[46] !== t4) {
    t21 = <AnimatedContent><div className="px-4 lg:px-0">{t4}{t20}</div></AnimatedContent>;
    $[45] = t20;
    $[46] = t4;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t) {
    t22 = t("revolvingLoan:cards.title");
    $[48] = t;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t22) {
    t23 = <div className="px-4 lg:px-0"><SectionHeadline variant="inverted" className="mb-10 lg:mb-16" anchorKey="revolvingLoan.cards.title">{t22}</SectionHeadline></div>;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== cards) {
    t24 = <StackCards imagePosition="left" cards={cards} />;
    $[52] = cards;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t23 || $[55] !== t24) {
    t25 = <AnimatedContent>{t23}{t24}</AnimatedContent>;
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t21 || $[58] !== t25) {
    t26 = <AnimatedSection bgColor="bg-blue-900" id={t2}>{t21}{t25}</AnimatedSection>;
    $[57] = t21;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  return t26;
}
export default Benefits;